import { Drop, House, PaintBrush, Thermometer, Wall, FileText, Package, UsersThree, Scales, MapPin, Receipt } from '@phosphor-icons/react';

export const projectTemplates = [
  {
    id: 'bathroom_basic',
    name: 'Basic Bathroom Remodel',
    icon: Drop,
    job_type: 'bathroom_remodel',
    description: 'Standard bathroom renovation including new vanity, toilet, tile flooring, and updated fixtures. Includes removal of old materials and basic plumbing connections.',
    square_footage: '75',
    timeline: '2-3 weeks'
  },
  {
    id: 'bathroom_full',
    name: 'Full Bathroom Renovation',
    icon: Drop,
    job_type: 'bathroom_remodel',
    description: 'Complete bathroom gut and remodel with new shower/tub, vanity, toilet, tile floors and walls, updated plumbing, electrical, and ventilation. Premium fixtures included.',
    square_footage: '100',
    timeline: '4-6 weeks'
  },
  {
    id: 'kitchen_basic',
    name: 'Kitchen Refresh',
    icon: House,
    job_type: 'kitchen_remodel',
    description: 'Kitchen update with cabinet refacing, new countertops, backsplash installation, and updated hardware. Existing layout maintained.',
    square_footage: '150',
    timeline: '2-3 weeks'
  },
  {
    id: 'kitchen_full',
    name: 'Full Kitchen Remodel',
    icon: House,
    job_type: 'kitchen_remodel',
    description: 'Complete kitchen renovation including new cabinets, countertops, appliances, flooring, lighting, plumbing, and electrical. Layout modifications included.',
    square_footage: '200',
    timeline: '6-8 weeks'
  },
  {
    id: 'roof_replacement',
    name: 'Roof Replacement',
    icon: House,
    job_type: 'roofing',
    description: 'Complete roof tear-off and replacement with architectural shingles. Includes new underlayment, flashing, ridge vents, and cleanup. 25-year warranty materials.',
    square_footage: '2000',
    timeline: '3-5 days'
  },
  {
    id: 'interior_paint',
    name: 'Whole House Interior Paint',
    icon: PaintBrush,
    job_type: 'painting',
    description: 'Interior painting for entire home including walls, ceilings, trim, and doors. Two coats of premium paint with proper prep work and primer where needed.',
    square_footage: '2500',
    timeline: '1-2 weeks'
  },
  {
    id: 'exterior_paint',
    name: 'Exterior House Painting',
    icon: PaintBrush,
    job_type: 'painting',
    description: 'Complete exterior painting including siding, trim, shutters, and doors. Power washing, scraping, priming, and two coats of weather-resistant paint.',
    square_footage: '2000',
    timeline: '1-2 weeks'
  },
  {
    id: 'deck_build',
    name: 'New Deck Construction',
    icon: House,
    job_type: 'deck_patio',
    description: 'New pressure-treated wood deck with stairs, railing, and basic design. Includes footings, framing, decking boards, and finishing.',
    square_footage: '300',
    timeline: '1-2 weeks'
  },
  {
    id: 'hvac_replace',
    name: 'HVAC System Replacement',
    icon: Thermometer,
    job_type: 'hvac',
    description: 'Complete HVAC system replacement including furnace and AC unit. Includes ductwork inspection, thermostat upgrade, and system balancing.',
    square_footage: '2000',
    timeline: '2-3 days'
  },
  {
    id: 'flooring_hardwood',
    name: 'Hardwood Floor Installation',
    icon: Wall,
    job_type: 'flooring',
    description: 'Solid hardwood floor installation including subfloor prep, moisture barrier, installation, sanding, and three coats of finish.',
    square_footage: '1000',
    timeline: '1-2 weeks'
  }
];

export const defaultLaborRates = {
  electrical: { min: 65, max: 95, default: 80 },
  plumbing: { min: 70, max: 100, default: 85 },
  roofing: { min: 50, max: 80, default: 65 },
  painting: { min: 35, max: 60, default: 45 },
  flooring: { min: 40, max: 70, default: 55 },
  hvac: { min: 75, max: 110, default: 90 },
  carpentry: { min: 45, max: 75, default: 60 },
  landscaping: { min: 35, max: 55, default: 45 },
  concrete: { min: 55, max: 85, default: 70 },
  drywall: { min: 40, max: 65, default: 50 },
  kitchen_remodel: { min: 55, max: 85, default: 70 },
  bathroom_remodel: { min: 55, max: 85, default: 70 },
  deck_patio: { min: 45, max: 70, default: 55 },
  fencing: { min: 40, max: 60, default: 50 },
  siding: { min: 50, max: 75, default: 60 },
  windows_doors: { min: 55, max: 80, default: 65 },
  insulation: { min: 40, max: 60, default: 50 },
  demolition: { min: 35, max: 55, default: 45 },
  foundation: { min: 60, max: 90, default: 75 },
  general_contractor: { min: 50, max: 80, default: 65 }
};

export const loadingSteps = [
  { id: 1, label: 'ANALYZING JOB SPECIFICATIONS', icon: FileText, duration: 2500 },
  { id: 2, label: 'CALCULATING MATERIAL QUANTITIES', icon: Package, duration: 3000 },
  { id: 3, label: 'ESTIMATING LABOR COSTS', icon: UsersThree, duration: 3000 },
  { id: 4, label: 'GENERATING PRICING TIERS', icon: Scales, duration: 2500 },
  { id: 5, label: 'APPLYING REGIONAL ADJUSTMENTS', icon: MapPin, duration: 2000 },
  { id: 6, label: 'FINALIZING QUOTE', icon: Receipt, duration: 2000 },
];
